export default __webpack_public_path__ + "static/media/feature-implemented.e7ab481d.png";